import isDefined from "./isDefined";

var getWidth = function getWidth(inline) {
  return isDefined(inline) && !inline && "100%";
};

export default getWidth;